export default __webpack_public_path__ + "static/media/newYear2024-large-tablet.c1383d6c.png";